import { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import SiteFooter from './components/SiteFooter';
const AmishCountryFinder = lazy(() => import('./AmishCountryFinder'));
const About = lazy(() => import('./About'));
const AdminUpload = lazy(() => import('./pages/AdminUpload'));
const BlogIndex = lazy(() => import('./blog/BlogIndex'));
const PrivacyPolicyPage = lazy(() => import('./pages/PrivacyPolicyPage'));
const TermsPage = lazy(() => import('./pages/TermsPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));















































const WhereToBuyAmishChowChow = lazy(() => import('./blog/WhereToBuyAmishChowChow'));
const WhereToBuyAmishBread = lazy(() => import('./blog/WhereToBuyAmishBread'));
const WhereToBuyAmishPies = lazy(() => import('./blog/WhereToBuyAmishPies'));











const DoAmishGoToTheDoctor = lazy(() => import('./blog/DoAmishGoToTheDoctor'));

const DoAmishCelebrateChristmas = lazy(() => import('./blog/DoAmishCelebrateChristmas'));
const DoAmishUseCreditCards = lazy(() => import('./blog/DoAmishUseCreditCards'));
const DoAmishGetMortgages = lazy(() => import('./blog/DoAmishGetMortgages'));
const DoAmishPayTaxes = lazy(() => import('./blog/DoAmishPayTaxes'));
const DoAmishHaveHealthInsurance = lazy(() => import('./blog/DoAmishHaveHealthInsurance'));
const DoAmishUseCellPhones = lazy(() => import('./blog/DoAmishUseCellPhones'));
const DoAmishUseSolarPower = lazy(() => import('./blog/DoAmishUseSolarPower'));
const AmishOpenMemorialDay = lazy(() => import('./blog/AmishOpenMemorialDay'));




























const NationalHomePage = lazy(() => import('./pages/national/HomePage'));
const MapPage = lazy(() => import('./pages/MapPage'));

























































const BusinessPage = lazy(() => import('./pages/BusinessPage'));


const NearMe = lazy(() => import('./pages/NearMe'));
const SearchResults = lazy(() => import('./pages/SearchResults'));


// --- Lazy-loaded routes (code-splitting for perf) ---
const MapleSyrupPost = lazy(() => import('./blog/MapleSyrupPost'));
const IrishRidgeSalesPost = lazy(() => import('./blog/IrishRidgeSalesPost'));
const AmishGreenhousesPost = lazy(() => import('./blog/AmishGreenhousesPost'));
const IrishRidgeGreenhousesPost = lazy(() => import('./blog/IrishRidgeGreenhousesPost'));
const TrailsEndPost = lazy(() => import('./blog/TrailsEndPost'));
const AmishEasterPost = lazy(() => import('./blog/AmishEasterPost'));
const MichiganCentrevillePost = lazy(() => import('./blog/MichiganCentrevillePost'));
const AmishFurniturePost = lazy(() => import('./blog/AmishFurniturePost'));
const MarionGreenhousesPost = lazy(() => import('./blog/MarionGreenhousesPost'));
const LongWayHomePost = lazy(() => import('./blog/LongWayHomePost'));
const OttosGreenhousePost = lazy(() => import('./blog/OttosGreenhousePost'));
const SunsetAcresPost = lazy(() => import('./blog/SunsetAcresPost'));
const GrabersGreenhousePost = lazy(() => import('./blog/GrabersGreenhousePost'));
const ClarkCountyGreenhousesPost = lazy(() => import('./blog/ClarkCountyGreenhousesPost'));
const MtEatonGreenhousePost = lazy(() => import('./blog/MtEatonGreenhousePost'));
const WinonaCountyGreenhousesPost = lazy(() => import('./blog/WinonaCountyGreenhousesPost'));
const VernonCountyGreenhousesPost = lazy(() => import('./blog/VernonCountyGreenhousesPost'));
const NewYorkGreenhousesPost = lazy(() => import('./blog/NewYorkGreenhousesPost'));
const AmishFlowersNearMePost = lazy(() => import('./blog/AmishFlowersNearMePost'));
const BloomingAcresGreenhousePost = lazy(() => import('./blog/BloomingAcresGreenhousePost'));
const TrempealeauCountyGreenhousesPost = lazy(() => import('./blog/TrempealeauCountyGreenhousesPost'));
const AscensionDayPost = lazy(() => import('./blog/AscensionDayPost'));
const FriendshipBreadPost = lazy(() => import('./blog/FriendshipBreadPost'));
const AppleButterPost = lazy(() => import('./blog/AppleButterPost'));
const SugarCookiesPost = lazy(() => import('./blog/SugarCookiesPost'));
const AmishDonutsPost = lazy(() => import('./blog/AmishDonutsPost'));
const ShooflypiePost = lazy(() => import('./blog/ShooflypiePost'));
const WhoopiesPiePost = lazy(() => import('./blog/WhoopiesPiePost'));
const ChickenPotPiePost = lazy(() => import('./blog/ChickenPotPiePost'));
const StickyBunsPost = lazy(() => import('./blog/StickyBunsPost'));
const PeanutButterSpreadPost = lazy(() => import('./blog/PeanutButterSpreadPost'));
const CornPuddingPost = lazy(() => import('./blog/CornPuddingPost'));
const ChowChowPost = lazy(() => import('./blog/ChowChowPost'));
const BakedOatmealPost = lazy(() => import('./blog/BakedOatmealPost'));
const SchnitzKneppPost = lazy(() => import('./blog/SchnitzKneppPost'));
const AmishWhiteBreadPost = lazy(() => import('./blog/AmishWhiteBreadPost'));
const FuneralPotatoesPost = lazy(() => import('./blog/FuneralPotatoesPost'));
const RivelSoupPost = lazy(() => import('./blog/RivelSoupPost'));
const ZucchiniBreadPost = lazy(() => import('./blog/ZucchiniBreadPost'));
const MacaroniSaladPost = lazy(() => import('./blog/MacaroniSaladPost'));
const OatmealPiePost = lazy(() => import('./blog/OatmealPiePost'));
const ApplesauceCakePost = lazy(() => import('./blog/ApplesauceCakePost'));
const SnickerdoodlePost = lazy(() => import('./blog/SnickerdoodlePost'));
const HaystackSupperPost = lazy(() => import('./blog/HaystackSupperPost'));
const TomatoGravyPost = lazy(() => import('./blog/TomatoGravyPost'));
const DatePuddingPost = lazy(() => import('./blog/DatePuddingPost'));
const PeanutButterCookiesPost = lazy(() => import('./blog/PeanutButterCookiesPost'));
const AmishBaseballPost = lazy(() => import('./blog/AmishBaseballPost'));
const WhatAreAmishPost = lazy(() => import('./blog/WhatAreAmishPost'));
const AmishVsMennonitePost = lazy(() => import('./blog/AmishVsMennonitePost'));
const AmishElectricityPost = lazy(() => import('./blog/AmishElectricityPost'));
const AmishMythsPost = lazy(() => import('./blog/AmishMythsPost'));
const AmishBeardsPost = lazy(() => import('./blog/AmishBeardsPost'));
const AmishBeardNoMustachePost = lazy(() => import('./blog/AmishBeardNoMustachePost'));
const RumspringaPost = lazy(() => import('./blog/RumspringaPost'));
const AmishDraftPost = lazy(() => import('./blog/AmishDraftPost'));
const AmishBooksPost = lazy(() => import('./blog/AmishBooksPost'));
const DoAmishVotePost = lazy(() => import('./blog/DoAmishVotePost'));
const WhatDoAmishEatPost = lazy(() => import('./blog/WhatDoAmishEatPost'));
const AmishMilitaryServicePost = lazy(() => import('./blog/AmishMilitaryServicePost'));
const AmishProduceAuctionsPost = lazy(() => import('./blog/AmishProduceAuctionsPost'));
const AmishMudSalesPost = lazy(() => import('./blog/AmishMudSalesPost'));
const AmishRoadsideStandsPost = lazy(() => import('./blog/AmishRoadsideStandsPost'));
const AmishFurnitureBuyingGuidePost = lazy(() => import('./blog/AmishFurnitureBuyingGuidePost'));
const AmishFallFoliagePost = lazy(() => import('./blog/AmishFallFoliagePost'));
const AmishGermanLanguagePost = lazy(() => import('./blog/AmishGermanLanguagePost'));
const WhyAmishDontDriveCarsPost = lazy(() => import('./blog/WhyAmishDontDriveCarsPost'));
const AmishHairCoveringPost = lazy(() => import('./blog/AmishHairCoveringPost'));
const AmishBowlHaircutPost = lazy(() => import('./blog/AmishBowlHaircutPost'));
const WhyAmishDontFlyPost = lazy(() => import('./blog/WhyAmishDontFlyPost'));
const WhyAmishMenWearHatsPost = lazy(() => import('./blog/WhyAmishMenWearHatsPost'));
const WhyAmishKidsAllergiesPost = lazy(() => import('./blog/WhyAmishKidsAllergiesPost'));
const WhyAmishCameToAmericaPost = lazy(() => import('./blog/WhyAmishCameToAmericaPost'));
const WhyAmishKidsWellBehavedPost = lazy(() => import('./blog/WhyAmishKidsWellBehavedPost'));
const WhyAmishGoBarefootPost = lazy(() => import('./blog/WhyAmishGoBarefootPost'));
const AmishMarriageAgePost = lazy(() => import('./blog/AmishMarriageAgePost'));
const WhyAmishUseHorsesPost = lazy(() => import('./blog/WhyAmishUseHorsesPost'));
const WhyAmishHorsesSkinnyPost = lazy(() => import('./blog/WhyAmishHorsesSkinnyPost'));
const WhyAmishDontRideHorsesPost = lazy(() => import('./blog/WhyAmishDontRideHorsesPost'));
const WhyAmishAreHealthyPost = lazy(() => import('./blog/WhyAmishAreHealthyPost'));
const AmishOrdnungPost = lazy(() => import('./blog/AmishOrdnungPost'));
const AmishShunningPost = lazy(() => import('./blog/AmishShunningPost'));
const WhyAmishLargeFamiliesPost = lazy(() => import('./blog/WhyAmishLargeFamiliesPost'));
const WhyNoPhotographAmishPost = lazy(() => import('./blog/WhyNoPhotographAmishPost'));
const AmishCountryEtiquettePost = lazy(() => import('./blog/AmishCountryEtiquettePost'));
const AmishThroughTheAgesPost = lazy(() => import('./blog/AmishThroughTheAgesPost'));
const AmishJulyFourthPost = lazy(() => import('./blog/AmishJulyFourthPost'));
const AmishHalloweenPost = lazy(() => import('./blog/AmishHalloweenPost'));
const AmishIceHarvestPost = lazy(() => import('./blog/AmishIceHarvestPost'));
const AmishSummerRefrigerationPost = lazy(() => import('./blog/AmishSummerRefrigerationPost'));
const AmishBuggyWinterWarmthPost = lazy(() => import('./blog/AmishBuggyWinterWarmthPost'));
const FourMileFurniturePost = lazy(() => import('./blog/FourMileFurniturePost'));
const HowManyAmishPost = lazy(() => import('./blog/HowManyAmishPost'));
const AmishWeddingPost = lazy(() => import('./blog/AmishWeddingPost'));
const AmishPinecraftPost = lazy(() => import('./blog/AmishPinecraftPost'));
const AmishChurchServicePost = lazy(() => import('./blog/AmishChurchServicePost'));
const AmishFuneralPost = lazy(() => import('./blog/AmishFuneralPost'));
const DoAmishBelieveInJesusPost = lazy(() => import('./blog/DoAmishBelieveInJesusPost'));
const CanYouLeaveAmishChurchPost = lazy(() => import('./blog/CanYouLeaveAmishChurchPost'));
const KitchenKettleVillagePost = lazy(() => import('./blog/KitchenKettleVillagePost'));
const StoltzfusMeatsPost = lazy(() => import('./blog/StoltzfusMeatsPost'));
const OldCountryStorePost = lazy(() => import('./blog/OldCountryStorePost'));
const MichiganAmishSettlementsPost = lazy(() => import('./blog/MichiganAmishSettlementsPost'));
const HillsdaleAmishSchoolStandoffPost = lazy(() => import('./blog/HillsdaleAmishSchoolStandoffPost'));
const AmishUpperPeninsulaPost = lazy(() => import('./blog/AmishUpperPeninsulaPost'));
const MichiganAmishFellowshipPost = lazy(() => import('./blog/MichiganAmishFellowshipPost'));
const CornellAmishBakeryPost = lazy(() => import('./blog/CornellAmishBakeryPost'));
const IowaCornfieldIncident1965Post = lazy(() => import('./blog/IowaCornfieldIncident1965Post'));
const IowaAmishSettlementsPost = lazy(() => import('./blog/IowaAmishSettlementsPost'));
const KalonaIowaPost = lazy(() => import('./blog/KalonaIowaPost'));
const BloomfieldIowaPost = lazy(() => import('./blog/BloomfieldIowaPost'));
const KalonaHistoricalVillagePost = lazy(() => import('./blog/KalonaHistoricalVillagePost'));
const OhioAmishSettlementsPost = lazy(() => import('./blog/OhioAmishSettlementsPost'));
const HolmesCounty12AffiliationsPost = lazy(() => import('./blog/HolmesCounty12AffiliationsPost'));
const SwartzentruberSplitPost = lazy(() => import('./blog/SwartzentruberSplitPost'));
const AmishCountryBywayPost = lazy(() => import('./blog/AmishCountryBywayPost'));
const WartherMuseumPost = lazy(() => import('./blog/WartherMuseumPost'));
const IndianaAmishSettlementsPost = lazy(() => import('./blog/IndianaAmishSettlementsPost'));
const SwissVsPennsylvaniaAmishPost = lazy(() => import('./blog/SwissVsPennsylvaniaAmishPost'));
const DaviessCountyTwangPost = lazy(() => import('./blog/DaviessCountyTwangPost'));
const GrabillIndianaPost = lazy(() => import('./blog/GrabillIndianaPost'));
const ElkhartLagrangeRVPost = lazy(() => import('./blog/ElkhartLagrangeRVPost'));
const NewYorkAmishSettlementsPost = lazy(() => import('./blog/NewYorkAmishSettlementsPost'));
const HeuveltonSwartzentruberPost = lazy(() => import('./blog/HeuveltonSwartzentruberPost'));
const MohawkValleyAmishPost = lazy(() => import('./blog/MohawkValleyAmishPost'));
const FastestGrowingAmishStatePost = lazy(() => import('./blog/FastestGrowingAmishStatePost'));
const NYAmishTrailLeonPost = lazy(() => import('./blog/NYAmishTrailLeonPost'));
const PennsylvaniaBeyondLancasterPost = lazy(() => import('./blog/PennsylvaniaBeyondLancasterPost'));
const BigValleyBuggyColorsPost = lazy(() => import('./blog/BigValleyBuggyColorsPost'));
const NewWilmingtonBrownToppedPost = lazy(() => import('./blog/NewWilmingtonBrownToppedPost'));
const SmicksburgAmishCountryPost = lazy(() => import('./blog/SmicksburgAmishCountryPost'));
const NebraskaAmishPost = lazy(() => import('./blog/NebraskaAmishPost'));
const AmishHeritageFoundationPost = lazy(() => import('./blog/AmishHeritageFoundationPost'));
const WisconsinAmishSettlementsPost = lazy(() => import('./blog/WisconsinAmishSettlementsPost'));
const KingstonDaltonWisconsinPost = lazy(() => import('./blog/KingstonDaltonWisconsinPost'));
const AugustaWisconsinAmishPost = lazy(() => import('./blog/AugustaWisconsinAmishPost'));
const GrantCountyFiveSettlementsPost = lazy(() => import('./blog/GrantCountyFiveSettlementsPost'));
const MedfordWisconsinPost = lazy(() => import('./blog/MedfordWisconsinPost'));
const HillsboroWisconsinPost = lazy(() => import('./blog/HillsboroWisconsinPost'));
const KentuckyAmishSettlementsPost = lazy(() => import('./blog/KentuckyAmishSettlementsPost'));
const GuthrieKentuckyPost = lazy(() => import('./blog/GuthrieKentuckyPost'));
const MarionKentuckyHomeShopPost = lazy(() => import('./blog/MarionKentuckyHomeShopPost'));
const MunfordvilleHartCountyPost = lazy(() => import('./blog/MunfordvilleHartCountyPost'));
const ScottsvilleAllenCountyMennonitePost = lazy(() => import('./blog/ScottsvilleAllenCountyMennonitePost'));
const KentuckyMigrationPatternsPost = lazy(() => import('./blog/KentuckyMigrationPatternsPost'));
const MissouriAmishSettlementsPost = lazy(() => import('./blog/MissouriAmishSettlementsPost'));
const SeymourMissouriSwissPost = lazy(() => import('./blog/SeymourMissouriSwissPost'));
const BowlingGreenMissouriPost = lazy(() => import('./blog/BowlingGreenMissouriPost'));
const ClarkMissouriAuctionPost = lazy(() => import('./blog/ClarkMissouriAuctionPost'));
const MissouriExtinctSettlementsPost = lazy(() => import('./blog/MissouriExtinctSettlementsPost'));
const MissouriAmishGrowthPost = lazy(() => import('./blog/MissouriAmishGrowthPost'));
const IllinoisAmishSettlementsPost = lazy(() => import('./blog/IllinoisAmishSettlementsPost'));
const ArthurIllinoisVisitorGuidePost = lazy(() => import('./blog/ArthurIllinoisVisitorGuidePost'));
const IllinoisHouseAmishPost = lazy(() => import('./blog/IllinoisHouseAmishPost'));
const IllinoisAmish1865Post = lazy(() => import('./blog/IllinoisAmish1865Post'));
const SouthernIllinoisAmishPost = lazy(() => import('./blog/SouthernIllinoisAmishPost'));
const ArthurFurnitureIndustryPost = lazy(() => import('./blog/ArthurFurnitureIndustryPost'));
const MinnesotaAmishSettlementsPost = lazy(() => import('./blog/MinnesotaAmishSettlementsPost'));
const HarmonyMinnesotaSwartzentruberPost = lazy(() => import('./blog/HarmonyMinnesotaSwartzentruberPost'));
const AmishToursHarmonyPost = lazy(() => import('./blog/AmishToursHarmonyPost'));
const ToddCountyMNSettlementsPost = lazy(() => import('./blog/ToddCountyMNSettlementsPost'));
const WadenaMNPost = lazy(() => import('./blog/WadenaMNPost'));
const MinnesotaAmishGrowthPost = lazy(() => import('./blog/MinnesotaAmishGrowthPost'));
const BeverlyLewisAuthorGuidePost = lazy(() => import('./blog/BeverlyLewisAuthorGuidePost'));
const WandaBrunstetterAuthorGuidePost = lazy(() => import('./blog/WandaBrunstetterAuthorGuidePost'));
const GrowingUpAmishWaglerPost = lazy(() => import('./blog/GrowingUpAmishWaglerPost'));
const TheAmishKraybillBookPost = lazy(() => import('./blog/TheAmishKraybillBookPost'));
const LindaCastilloKateBurkholderPost = lazy(() => import('./blog/LindaCastilloKateBurkholderPost'));
const AmishMemoirsExAmishPost = lazy(() => import('./blog/AmishMemoirsExAmishPost'));
const AmishSocietyHostetlerBookPost = lazy(() => import('./blog/AmishSocietyHostetlerBookPost'));
const StrawberryRhubarbPiePost = lazy(() => import('./blog/StrawberryRhubarbPiePost'));
const WiltedLettuceSaladPost = lazy(() => import('./blog/WiltedLettuceSaladPost'));
const RhubarbCrunchPost = lazy(() => import('./blog/RhubarbCrunchPost'));
const OhioGreenhousesPost = lazy(() => import('./blog/OhioGreenhousesPost'));
const IndianaGreenhousesPost = lazy(() => import('./blog/IndianaGreenhousesPost'));
const LancasterCountyPost = lazy(() => import('./blog/LancasterCountyPost'));
const HolmesCountyPost = lazy(() => import('./blog/HolmesCountyPost'));
const ShipshewanaPost = lazy(() => import('./blog/ShipshewanaPost'));
const SubmitBusiness = lazy(() => import('./pages/SubmitBusiness'));
const AdminSubmissions = lazy(() => import('./pages/AdminSubmissions'));
const EventsPage = lazy(() => import('./pages/EventsPage'));
const VernonCountyPage = lazy(() => import('./pages/VernonCountyPage'));
const GreenLakeCountyPage = lazy(() => import('./pages/GreenLakeCountyPage'));
const VernonCountyDirectoryPage = lazy(() => import('./pages/national/VernonCountyDirectoryPage'));
const MonroeCountyDirectoryPage = lazy(() => import('./pages/national/MonroeCountyDirectoryPage'));
const GreenLakeCountyDirectoryPage = lazy(() => import('./pages/national/GreenLakeCountyDirectoryPage'));
const ShawanoCountyDirectoryPage = lazy(() => import('./pages/national/ShawanoCountyDirectoryPage'));
const ClarkCountyDirectoryPage = lazy(() => import('./pages/national/ClarkCountyDirectoryPage'));
const CashtonPage = lazy(() => import('./pages/CashtonPage'));
const DaltonPage = lazy(() => import('./pages/DaltonPage'));
const OntarioPage = lazy(() => import('./pages/OntarioPage'));
const KingstonPage = lazy(() => import('./pages/KingstonPage'));
const PennsylvaniaPage = lazy(() => import('./pages/national/PennsylvaniaPage'));
const PennsylvaniaDirectoryPage = lazy(() => import('./pages/national/PennsylvaniaDirectoryPage'));
const LancasterCountyDirectoryPage = lazy(() => import('./pages/national/LancasterCountyDirectoryPage'));
const CrawfordCountyDirectoryPage = lazy(() => import('./pages/national/CrawfordCountyDirectoryPage'));
const LawrenceCountyDirectoryPage = lazy(() => import('./pages/national/LawrenceCountyDirectoryPage'));
const MifflinCountyDirectoryPage = lazy(() => import('./pages/national/MifflinCountyDirectoryPage'));
const OhioPage = lazy(() => import('./pages/national/OhioPage'));
const OhioDirectoryPage = lazy(() => import('./pages/national/OhioDirectoryPage'));
const HolmesCountyDirectoryPage = lazy(() => import('./pages/national/HolmesCountyDirectoryPage'));
const WayneCountyOhioDirectoryPage = lazy(() => import('./pages/national/WayneCountyOhioDirectoryPage'));
const TuscarawasCountyDirectoryPage = lazy(() => import('./pages/national/TuscarawasCountyDirectoryPage'));
const GeaugaCountyDirectoryPage = lazy(() => import('./pages/national/GeaugaCountyDirectoryPage'));
const IndianaDirectoryPage = lazy(() => import('./pages/national/IndianaDirectoryPage'));
const LaGrangeCountyDirectoryPage = lazy(() => import('./pages/national/LaGrangeCountyDirectoryPage'));
const ElkhartCountyDirectoryPage = lazy(() => import('./pages/national/ElkhartCountyDirectoryPage'));
const DaviessCountyDirectoryPage = lazy(() => import('./pages/national/DaviessCountyDirectoryPage'));
const IllinoisDirectoryPage = lazy(() => import('./pages/national/IllinoisDirectoryPage'));
const NewYorkDirectoryPage = lazy(() => import('./pages/national/NewYorkDirectoryPage'));
const IndianaPage = lazy(() => import('./pages/national/IndianaPage'));
const NewYorkPage = lazy(() => import('./pages/national/NewYorkPage'));
const MichiganPage = lazy(() => import('./pages/national/MichiganPage'));
const MichiganDirectoryPage = lazy(() => import('./pages/national/MichiganDirectoryPage'));
const StJosephCountyMIDirectoryPage = lazy(() => import('./pages/national/StJosephCountyMIDirectoryPage'));
const HillsdaleCountyDirectoryPage = lazy(() => import('./pages/national/HillsdaleCountyDirectoryPage'));
const DouglasCountyILDirectoryPage = lazy(() => import('./pages/national/DouglasCountyILDirectoryPage'));
const MinnesotaDirectoryPage = lazy(() => import('./pages/national/MinnesotaDirectoryPage'));
const FillmoreCountyDirectoryPage = lazy(() => import('./pages/national/FillmoreCountyDirectoryPage'));
const HoustonCountyDirectoryPage = lazy(() => import('./pages/national/HoustonCountyDirectoryPage'));
const DaviessCountyMODirectoryPage = lazy(() => import('./pages/national/DaviessCountyMODirectoryPage'));
const CattaraugusCountyDirectoryPage = lazy(() => import('./pages/national/CattaraugusCountyDirectoryPage'));
const YatesCountyDirectoryPage = lazy(() => import('./pages/national/YatesCountyDirectoryPage'));
const StLawrenceCountyDirectoryPage = lazy(() => import('./pages/national/StLawrenceCountyDirectoryPage'));
const PrintableGuides = lazy(() => import('./pages/PrintableGuides'));
const GreenhousesPage = lazy(() => import('./pages/GreenhousesPage'));
const SubmitPDF = lazy(() => import('./pages/SubmitPDF'));
const WisconsinDellsGuide = lazy(() => import('./pages/print/WisconsinDellsGuide'));
const HolmesCountyGuide = lazy(() => import('./pages/print/HolmesCountyGuide'));
const JamesportGuide = lazy(() => import('./pages/print/JamesportGuide'));
const ArthurArcolaGuide = lazy(() => import('./pages/print/ArthurArcolaGuide'));
const ShipshewanaGuide = lazy(() => import('./pages/print/ShipshewanaGuide'));
const MissouriDirectoryPage = lazy(() => import('./pages/national/MissouriDirectoryPage'));
const WashingtonCountyIADirectoryPage = lazy(() => import('./pages/national/WashingtonCountyIADirectoryPage'));
const DavisCountyIADirectoryPage = lazy(() => import('./pages/national/DavisCountyIADirectoryPage'));
const GraysonCountyKYDirectoryPage = lazy(() => import('./pages/national/GraysonCountyKYDirectoryPage'));
const HartCountyKYDirectoryPage = lazy(() => import('./pages/national/HartCountyKYDirectoryPage'));
const LoganCountyKYDirectoryPage = lazy(() => import('./pages/national/LoganCountyKYDirectoryPage'));
const KentuckyPage = lazy(() => import('./pages/national/KentuckyPage'));
const KentuckyDirectoryPage = lazy(() => import('./pages/national/KentuckyDirectoryPage'));
const IllinoisPage = lazy(() => import('./pages/national/IllinoisPage'));
const IowaPage = lazy(() => import('./pages/national/IowaPage'));
const IowaDirectoryPage = lazy(() => import('./pages/national/IowaDirectoryPage'));
const WisconsinPage = lazy(() => import('./pages/national/WisconsinPage'));
const GrantCountyWIDirectoryPage = lazy(() => import('./pages/national/GrantCountyWIDirectoryPage'));
const LafayetteCountyWIDirectoryPage = lazy(() => import('./pages/national/LafayetteCountyWIDirectoryPage'));
const VisitorGuidePage = lazy(() => import('./pages/VisitorGuidePage'));
const VisitingGuide = lazy(() => import('./pages/VisitingGuide'));
const GuidePage = lazy(() => import('./pages/guides/GuidePage'));
const TripList = lazy(() => import('./pages/TripList'));
const AdminBusinesses = lazy(() => import('./pages/AdminBusinesses'));
const AmishStoresNearMe = lazy(() => import('./pages/AmishStoresNearMe'));
const YodersKuntryMarketClarePost = lazy(() => import('./blog/YodersKuntryMarketClarePost'));
const SmicksburgShoppingGuidePost = lazy(() => import('./blog/SmicksburgShoppingGuidePost'));
const ClarkMissouriShoppingGuidePost = lazy(() => import('./blog/ClarkMissouriShoppingGuidePost'));
const IrishRidgeCashtonPost = lazy(() => import('./blog/IrishRidgeCashtonPost'));
const HeartlandBulkFoodsCubaIllinoisPost = lazy(() => import('./blog/HeartlandBulkFoodsCubaIllinoisPost'));
const NappaneeIndianaAmishPost = lazy(() => import('./blog/NappaneeIndianaAmishPost'));
const WhereSwartzentruberAmishLivePost = lazy(() => import('./blog/WhereSwartzentruberAmishLivePost'));
const DoAmishHuntPost = lazy(() => import('./blog/DoAmishHuntPost'));
const AmishDeerHuntingPABuckSeasonPost = lazy(() => import('./blog/AmishDeerHuntingPABuckSeasonPost'));
const DoAmishOwnGunsPost = lazy(() => import('./blog/DoAmishOwnGunsPost'));
const AmishFishingTraditionsPost = lazy(() => import('./blog/AmishFishingTraditionsPost'));
const AmishDeerCampsPost = lazy(() => import('./blog/AmishDeerCampsPost'));
const AmishTrappingTraditionPost = lazy(() => import('./blog/AmishTrappingTraditionPost'));
const AmishBowHuntingArcheryPost = lazy(() => import('./blog/AmishBowHuntingArcheryPost'));
const AmishSchoolsPost = lazy(() => import('./blog/AmishSchoolsPost'));
const AmishMarketsNearMe = lazy(() => import('./pages/AmishMarketsNearMe'));
const AmishLeatherShopsPost = lazy(() => import('./blog/AmishLeatherShopsPost'));
const AmishBentAndDentSalvagePost = lazy(() => import('./blog/AmishBentAndDentSalvagePost'));
const AmishFarmsNearMe = lazy(() => import('./pages/AmishFarmsNearMe'));
const MontgomeryIndianaAmishPost = lazy(() => import('./blog/MontgomeryIndianaAmishPost'));
const KalonaIowaAmishStoresPost = lazy(() => import('./blog/KalonaIowaAmishStoresPost'));
const AmishVegetableStandsNearMe = lazy(() => import('./pages/AmishVegetableStandsNearMe'));
const AmishPotatoSaladPost = lazy(() => import('./blog/AmishPotatoSaladPost'));
const AmishGreenhousesNearMe = lazy(() => import('./pages/AmishGreenhousesNearMe'));
const SugarcreekAmishMysteriesPost = lazy(() => import('./blog/SugarcreekAmishMysteriesPost'));
const BlackAmishPost = lazy(() => import('./blog/BlackAmishPost'));
const WhatIsAMennonitePost = lazy(() => import('./blog/WhatIsAMennonitePost'));
const MennoniteHeadCoveringPost = lazy(() => import('./blog/MennoniteHeadCoveringPost'));
const AmishBakeryNearMe = lazy(() => import('./pages/AmishBakeryNearMe'));
const WinnersPage = lazy(() => import('./pages/WinnersPage'));
const LovinaZookPost = lazy(() => import('./blog/LovinaZookPost'));
const WhoAreSwartzentruberPost = lazy(() => import('./blog/WhoAreSwartzentruberPost'));
const AmishCoffeeSoupPost = lazy(() => import('./blog/AmishCoffeeSoupPost'));
const AmishPeanutButterPiePost = lazy(() => import('./blog/AmishPeanutButterPiePost'));
const ExAmishCreatorsPost = lazy(() => import('./blog/ExAmishCreatorsPost'));
const AmishCheeseburgerPost = lazy(() => import('./blog/AmishCheeseburgerPost'));
const AmishPoorMansSteakPost = lazy(() => import('./blog/AmishPoorMansSteakPost'));
const AmishHomemadeButterPost = lazy(() => import('./blog/AmishHomemadeButterPost'));
const AmishGrapeJellyPost = lazy(() => import('./blog/AmishGrapeJellyPost'));
const PennsylvaniaDutchLanguagePost = lazy(() => import('./blog/PennsylvaniaDutchLanguagePost'));
const AmishDressGuidePost = lazy(() => import('./blog/AmishDressGuidePost'));
const LovinaZookHub = lazy(() => import('./pages/LovinaZookHub'));
const EliZookHusbandPost = lazy(() => import('./blog/EliZookHusbandPost'));
const HowDoAmishDatePost = lazy(() => import('./blog/HowDoAmishDatePost'));
const AmishBundlingBedCourtshipPost = lazy(() => import('./blog/AmishBundlingBedCourtshipPost'));
const HowAmishWomenStyleHairPost = lazy(() => import('./blog/HowAmishWomenStyleHairPost'));
const AmishHomeRemediesPost = lazy(() => import('./blog/AmishHomeRemediesPost'));
const AmishPregnancyBirthPost = lazy(() => import('./blog/AmishPregnancyBirthPost'));
const AmishHarvestCanningPost = lazy(() => import('./blog/AmishHarvestCanningPost'));
const AmishChickenCornSoupPost = lazy(() => import('./blog/AmishChickenCornSoupPost'));
const AmishHomemadeMarshmallowsPost = lazy(() => import('./blog/AmishHomemadeMarshmallowsPost'));
const AmishCornHarvestPost = lazy(() => import('./blog/AmishCornHarvestPost'));
const ShopPage = lazy(() => import('./pages/ShopPage'));
const AmishWinterHeatingPost = lazy(() => import('./blog/AmishWinterHeatingPost'));
const CookingOnWoodStovePost = lazy(() => import('./blog/CookingOnWoodStovePost'));
const LovinaZookBabyBornPost = lazy(() => import('./blog/LovinaZookBabyBornPost'));
const ReportListingPage = lazy(() => import('./pages/ReportListingPage'));
const WapsieValleyProduceAuctionPost = lazy(() => import('./blog/WapsieValleyProduceAuctionPost'));
const ClymerNYAmishBusinessesPost = lazy(() => import('./blog/ClymerNYAmishBusinessesPost'));
const DutchCountryStoreBarnettMOPost = lazy(() => import('./blog/DutchCountryStoreBarnettMOPost'));

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<div style={{minHeight:'60vh',display:'flex',alignItems:'center',justifyContent:'center',color:'#8a7a68',fontSize:14}}>Loading…</div>}><Routes>
        <Route path="/" element={<NationalHomePage />} />
        <Route path="/amish-stores-near-me" element={<AmishStoresNearMe />} />
        <Route path="/blog/yoders-kuntry-market-clare-michigan" element={<YodersKuntryMarketClarePost />} />
        <Route path="/blog/smicksburg-pa-amish-shopping-guide" element={<SmicksburgShoppingGuidePost />} />
        <Route path="/blog/clark-missouri-amish-shopping-guide" element={<ClarkMissouriShoppingGuidePost />} />
        <Route path="/blog/irish-ridge-cashton-wisconsin-amish-businesses" element={<IrishRidgeCashtonPost />} />
        <Route path="/blog/four-mile-furniture-jackson-ohio" element={<FourMileFurniturePost />} />
        <Route path="/blog/heartland-bulk-foods-cuba-illinois-amish" element={<HeartlandBulkFoodsCubaIllinoisPost />} />
        <Route path="/blog/nappanee-indiana-amish-country" element={<NappaneeIndianaAmishPost />} />
        <Route path="/blog/where-swartzentruber-amish-live" element={<WhereSwartzentruberAmishLivePost />} />
        <Route path="/blog/do-amish-hunt" element={<DoAmishHuntPost />} />
        <Route path="/blog/amish-deer-hunting-pennsylvania-buck-season" element={<AmishDeerHuntingPABuckSeasonPost />} />
        <Route path="/blog/do-amish-own-guns-firearms" element={<DoAmishOwnGunsPost />} />
        <Route path="/blog/amish-fishing-traditions" element={<AmishFishingTraditionsPost />} />
        <Route path="/blog/amish-deer-camps" element={<AmishDeerCampsPost />} />
        <Route path="/blog/amish-trapping-tradition" element={<AmishTrappingTraditionPost />} />
        <Route path="/blog/amish-bow-hunting-archery" element={<AmishBowHuntingArcheryPost />} />
        <Route path="/blog/amish-schools-education" element={<AmishSchoolsPost />} />
        <Route path="/amish-markets-near-me" element={<AmishMarketsNearMe />} />
        <Route path="/blog/amish-leather-shops" element={<AmishLeatherShopsPost />} />
        <Route path="/blog/amish-bent-and-dent-salvage-grocery" element={<AmishBentAndDentSalvagePost />} />
        <Route path="/amish-farms-near-me" element={<AmishFarmsNearMe />} />
        <Route path="/blog/montgomery-indiana-amish" element={<MontgomeryIndianaAmishPost />} />
        <Route path="/blog/kalona-iowa-amish-stores" element={<KalonaIowaAmishStoresPost />} />
        <Route path="/amish-vegetable-stands-near-me" element={<AmishVegetableStandsNearMe />} />
        <Route path="/blog/amish-potato-salad-recipe" element={<AmishPotatoSaladPost />} />
        <Route path="/amish-greenhouses-near-me" element={<AmishGreenhousesNearMe />} />
        <Route path="/blog/sugarcreek-amish-mysteries" element={<SugarcreekAmishMysteriesPost />} />
        <Route path="/blog/black-amish-racial-diversity" element={<BlackAmishPost />} />
        <Route path="/blog/what-is-a-mennonite" element={<WhatIsAMennonitePost />} />
        <Route path="/blog/mennonite-head-covering" element={<MennoniteHeadCoveringPost />} />
        <Route path="/amish-bakery-near-me" element={<AmishBakeryNearMe />} />
        <Route path="/winners" element={<WinnersPage />} />
        <Route path="/blog/lovina-zook-ex-amish-tiktok-creator" element={<LovinaZookPost />} />
        <Route path="/blog/who-are-swartzentruber-amish" element={<WhoAreSwartzentruberPost />} />
        <Route path="/blog/amish-coffee-soup-recipe" element={<AmishCoffeeSoupPost />} />
        <Route path="/blog/amish-peanut-butter-pie-recipe" element={<AmishPeanutButterPiePost />} />
        <Route path="/blog/ex-amish-creators-and-voices" element={<ExAmishCreatorsPost />} />
        <Route path="/blog/amish-cheeseburger-recipe" element={<AmishCheeseburgerPost />} />
        <Route path="/blog/amish-poor-mans-steak-recipe" element={<AmishPoorMansSteakPost />} />
        <Route path="/blog/amish-homemade-butter-recipe" element={<AmishHomemadeButterPost />} />
        <Route path="/blog/amish-grape-jelly-recipe" element={<AmishGrapeJellyPost />} />
        <Route path="/blog/pennsylvania-dutch-language" element={<PennsylvaniaDutchLanguagePost />} />
        <Route path="/blog/amish-dress-plain-clothing-guide" element={<AmishDressGuidePost />} />
        <Route path="/lovina-zook" element={<LovinaZookHub />} />
        <Route path="/blog/who-is-eli-zook-lovina-husband" element={<EliZookHusbandPost />} />
        <Route path="/blog/how-do-amish-date-courtship-traditions" element={<HowDoAmishDatePost />} />
        <Route path="/blog/amish-bundling-bed-courtship" element={<AmishBundlingBedCourtshipPost />} />
        <Route path="/blog/how-amish-women-style-their-hair" element={<HowAmishWomenStyleHairPost />} />
        <Route path="/blog/amish-home-remedies" element={<AmishHomeRemediesPost />} />
        <Route path="/blog/amish-pregnancy-home-birth-midwifery" element={<AmishPregnancyBirthPost />} />
        <Route path="/blog/amish-harvest-canning-traditions" element={<AmishHarvestCanningPost />} />
        <Route path="/blog/amish-chicken-corn-soup-recipe" element={<AmishChickenCornSoupPost />} />
        <Route path="/blog/amish-homemade-marshmallows-recipe" element={<AmishHomemadeMarshmallowsPost />} />
        <Route path="/blog/amish-corn-harvest-field-methods" element={<AmishCornHarvestPost />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/blog/how-amish-heat-their-homes-winter" element={<AmishWinterHeatingPost />} />
        <Route path="/blog/cooking-on-a-wood-stove-amish-kitchen" element={<CookingOnWoodStovePost />} />
        <Route path="/blog/lovina-zook-baby-eliana-born" element={<LovinaZookBabyBornPost />} />
        <Route path="/report-listing" element={<ReportListingPage />} />
        <Route path="/blog/wapsie-valley-produce-auction" element={<WapsieValleyProduceAuctionPost />} />
        <Route path="/blog/clymer-ny-amish-businesses" element={<ClymerNYAmishBusinessesPost />} />
        <Route path="/blog/dutch-country-store-barnett-missouri" element={<DutchCountryStoreBarnettMOPost />} />
        <Route path="/about" element={<About />} />
        <Route path="/acf-admin/upload" element={<AdminUpload />} />
        <Route path="/visiting-amish-country" element={<VisitingGuide />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/amish-maple-syrup-wisconsin" element={<MapleSyrupPost />} />
        <Route path="/blog/irish-ridge-sales-cashton-wi" element={<IrishRidgeSalesPost />} />
        <Route path="/blog/amish-greenhouses-wisconsin-spring" element={<AmishGreenhousesPost />} />
        <Route path="/blog/irish-ridge-road-greenhouses-cashton-wi" element={<IrishRidgeGreenhousesPost />} />
        <Route path="/blog/trails-end-amish-walmart-ontario-wi" element={<TrailsEndPost />} />
        <Route path="/blog/do-amish-celebrate-easter" element={<AmishEasterPost />} />
        <Route path="/blog/largest-amish-community-michigan-centreville-st-joseph-county" element={<MichiganCentrevillePost />} />
        <Route path="/blog/amish-furniture-quality-craftsmanship" element={<AmishFurniturePost />} />
        <Route path="/blog/amish-greenhouses-marion-wi" element={<MarionGreenhousesPost />} />
        <Route path="/blog/amish-greenhouses-long-way-home" element={<LongWayHomePost />} />
        <Route path="/blog/ottos-produce-greenhouse-dalton-wi" element={<OttosGreenhousePost />} />
        <Route path="/blog/sunset-acres-greenhouse-marion-wi" element={<SunsetAcresPost />} />
        <Route path="/blog/grabers-greenhouse-jamesport-missouri" element={<GrabersGreenhousePost />} />
        <Route path="/blog/amish-greenhouses-clark-county-wisconsin" element={<ClarkCountyGreenhousesPost />} />
        <Route path="/blog/mt-eaton-greenhouse-apple-creek-ohio" element={<MtEatonGreenhousePost />} />
        <Route path="/blog/amish-greenhouses-winona-county-minnesota" element={<WinonaCountyGreenhousesPost />} />
        <Route path="/blog/amish-greenhouses-vernon-county-wisconsin" element={<VernonCountyGreenhousesPost />} />
        <Route path="/blog/amish-greenhouses-new-york" element={<NewYorkGreenhousesPost />} />
        <Route path="/blog/amish-flowers-near-me" element={<AmishFlowersNearMePost />} />
        <Route path="/blog/blooming-acres-greenhouse-marion-wi" element={<BloomingAcresGreenhousePost />} />
        <Route path="/blog/amish-greenhouses-trempealeau-county-wisconsin" element={<TrempealeauCountyGreenhousesPost />} />
        <Route path="/blog/amish-greenhouses-closed-ascension-day" element={<AscensionDayPost />} />
        <Route path="/blog/amish-friendship-bread-recipe" element={<FriendshipBreadPost />} />
        <Route path="/blog/amish-apple-butter-recipe" element={<AppleButterPost />} />
        <Route path="/blog/amish-sugar-cookies-recipe" element={<SugarCookiesPost />} />
        <Route path="/blog/amish-donuts-recipe" element={<AmishDonutsPost />} />
        <Route path="/blog/shoofly-pie-recipe" element={<ShooflypiePost />} />
        <Route path="/blog/amish-whoopie-pie-recipe" element={<WhoopiesPiePost />} />
        <Route path="/blog/amish-chicken-pot-pie-recipe" element={<ChickenPotPiePost />} />
        <Route path="/blog/amish-sticky-buns-recipe" element={<StickyBunsPost />} />
        <Route path="/blog/amish-peanut-butter-spread-recipe" element={<PeanutButterSpreadPost />} />
        <Route path="/blog/amish-corn-pudding-recipe" element={<CornPuddingPost />} />
        <Route path="/blog/amish-chow-chow-recipe" element={<ChowChowPost />} />
        <Route path="/blog/amish-baked-oatmeal-recipe" element={<BakedOatmealPost />} />
        <Route path="/blog/schnitz-un-knepp-recipe" element={<SchnitzKneppPost />} />
        <Route path="/blog/amish-white-bread-recipe" element={<AmishWhiteBreadPost />} />
        <Route path="/blog/amish-funeral-potatoes-recipe" element={<FuneralPotatoesPost />} />
        <Route path="/blog/amish-rivel-soup-recipe" element={<RivelSoupPost />} />
        <Route path="/blog/amish-zucchini-bread-recipe" element={<ZucchiniBreadPost />} />
        <Route path="/blog/amish-macaroni-salad-recipe" element={<MacaroniSaladPost />} />
        <Route path="/blog/amish-oatmeal-pie-recipe" element={<OatmealPiePost />} />
        <Route path="/blog/amish-applesauce-cake-recipe" element={<ApplesauceCakePost />} />
        <Route path="/blog/amish-snickerdoodle-recipe" element={<SnickerdoodlePost />} />
        <Route path="/blog/amish-haystack-supper-recipe" element={<HaystackSupperPost />} />
        <Route path="/blog/amish-tomato-gravy-recipe" element={<TomatoGravyPost />} />
        <Route path="/blog/amish-date-pudding-recipe" element={<DatePuddingPost />} />
        <Route path="/blog/amish-peanut-butter-cookies-recipe" element={<PeanutButterCookiesPost />} />
        <Route path="/blog/where-to-buy-amish-chow-chow" element={<WhereToBuyAmishChowChow />} />
        <Route path="/blog/where-to-buy-amish-bread" element={<WhereToBuyAmishBread />} />
        <Route path="/blog/where-to-buy-amish-pies" element={<WhereToBuyAmishPies />} />
        <Route path="/blog/amish-baseball-softball" element={<AmishBaseballPost />} />
        <Route path="/blog/what-are-amish-people" element={<WhatAreAmishPost />} />
        <Route path="/blog/amish-vs-mennonite-difference" element={<AmishVsMennonitePost />} />
        <Route path="/blog/do-amish-use-electricity" element={<AmishElectricityPost />} />
        <Route path="/blog/amish-myths-debunked" element={<AmishMythsPost />} />
        <Route path="/blog/when-do-amish-grow-beards" element={<AmishBeardsPost />} />
        <Route path="/blog/amish-beard-no-mustache" element={<AmishBeardNoMustachePost />} />
        <Route path="/blog/what-is-rumspringa" element={<RumspringaPost />} />
        <Route path="/blog/do-amish-register-for-draft" element={<AmishDraftPost />} />
        <Route path="/blog/best-amish-books" element={<AmishBooksPost />} />
        <Route path="/blog/do-amish-vote" element={<DoAmishVotePost />} />
        <Route path="/blog/do-amish-go-to-the-doctor" element={<DoAmishGoToTheDoctor />} />
        <Route path="/blog/what-do-amish-eat" element={<WhatDoAmishEatPost />} />
        <Route path="/blog/do-amish-celebrate-christmas" element={<DoAmishCelebrateChristmas />} />
        <Route path="/blog/do-amish-use-credit-cards" element={<DoAmishUseCreditCards />} />
        <Route path="/blog/do-amish-get-mortgages" element={<DoAmishGetMortgages />} />
        <Route path="/blog/do-amish-pay-taxes" element={<DoAmishPayTaxes />} />
        <Route path="/blog/do-amish-have-health-insurance" element={<DoAmishHaveHealthInsurance />} />
        <Route path="/blog/do-amish-use-cell-phones" element={<DoAmishUseCellPhones />} />
        <Route path="/blog/do-amish-use-solar-power" element={<DoAmishUseSolarPower />} />
        <Route path="/blog/are-amish-stores-open-memorial-day" element={<AmishOpenMemorialDay />} />
        <Route path="/blog/amish-military-service-pacifism" element={<AmishMilitaryServicePost />} />
        <Route path="/blog/amish-produce-auctions-2026" element={<AmishProduceAuctionsPost />} />
        <Route path="/blog/amish-mud-sales-relief-sales-2026" element={<AmishMudSalesPost />} />
        <Route path="/blog/amish-roadside-stands-month-by-month" element={<AmishRoadsideStandsPost />} />
        <Route path="/blog/amish-furniture-buying-guide-2026" element={<AmishFurnitureBuyingGuidePost />} />
        <Route path="/blog/amish-country-fall-foliage-2026" element={<AmishFallFoliagePost />} />
        <Route path="/blog/why-amish-speak-german" element={<AmishGermanLanguagePost />} />
        <Route path="/blog/why-amish-dont-drive-cars" element={<WhyAmishDontDriveCarsPost />} />
        <Route path="/blog/why-amish-women-cover-hair" element={<AmishHairCoveringPost />} />
        <Route path="/blog/why-amish-men-bowl-haircut" element={<AmishBowlHaircutPost />} />
        <Route path="/blog/why-amish-dont-fly" element={<WhyAmishDontFlyPost />} />
        <Route path="/blog/why-amish-men-wear-hats" element={<WhyAmishMenWearHatsPost />} />
        <Route path="/blog/why-amish-kids-dont-get-allergies" element={<WhyAmishKidsAllergiesPost />} />
        <Route path="/blog/why-amish-came-to-america" element={<WhyAmishCameToAmericaPost />} />
        <Route path="/blog/why-amish-kids-well-behaved" element={<WhyAmishKidsWellBehavedPost />} />
        <Route path="/blog/why-amish-kids-go-barefoot" element={<WhyAmishGoBarefootPost />} />
        <Route path="/blog/what-age-do-amish-marry-have-children" element={<AmishMarriageAgePost />} />
        <Route path="/blog/why-amish-use-horses" element={<WhyAmishUseHorsesPost />} />
        <Route path="/blog/why-amish-horses-skinny" element={<WhyAmishHorsesSkinnyPost />} />
        <Route path="/blog/why-amish-dont-ride-horses" element={<WhyAmishDontRideHorsesPost />} />
        <Route path="/blog/why-amish-are-healthy" element={<WhyAmishAreHealthyPost />} />
        <Route path="/blog/what-is-amish-ordnung" element={<AmishOrdnungPost />} />
        <Route path="/blog/what-is-amish-shunning" element={<AmishShunningPost />} />
        <Route path="/blog/why-amish-have-many-children" element={<WhyAmishLargeFamiliesPost />} />
        <Route path="/blog/why-cant-photograph-amish" element={<WhyNoPhotographAmishPost />} />
        <Route path="/blog/amish-country-etiquette" element={<AmishCountryEtiquettePost />} />
        <Route path="/blog/amish-history-through-ages" element={<AmishThroughTheAgesPost />} />
        <Route path="/blog/do-amish-celebrate-fourth-of-july" element={<AmishJulyFourthPost />} />
        <Route path="/blog/do-amish-celebrate-halloween" element={<AmishHalloweenPost />} />
        <Route path="/blog/amish-ice-harvesting" element={<AmishIceHarvestPost />} />
        <Route path="/blog/amish-summer-refrigeration" element={<AmishSummerRefrigerationPost />} />
        <Route path="/blog/amish-buggy-winter-warmth" element={<AmishBuggyWinterWarmthPost />} />
        <Route path="/blog/how-many-amish-where-they-live" element={<HowManyAmishPost />} />
        <Route path="/blog/what-is-amish-wedding-like" element={<AmishWeddingPost />} />
        <Route path="/blog/amish-pinecraft-florida" element={<AmishPinecraftPost />} />
        <Route path="/blog/what-is-amish-church-service-like" element={<AmishChurchServicePost />} />
        <Route path="/blog/what-is-amish-funeral-like" element={<AmishFuneralPost />} />
        <Route path="/blog/do-amish-believe-in-jesus" element={<DoAmishBelieveInJesusPost />} />
        <Route path="/blog/can-you-leave-amish-church" element={<CanYouLeaveAmishChurchPost />} />
        <Route path="/blog/kitchen-kettle-village-intercourse-pa" element={<KitchenKettleVillagePost />} />
        <Route path="/blog/stoltzfus-meats-intercourse-pa" element={<StoltzfusMeatsPost />} />
        <Route path="/blog/old-country-store-intercourse-pa" element={<OldCountryStorePost />} />
        <Route path="/blog/where-are-amish-in-michigan" element={<MichiganAmishSettlementsPost />} />
        <Route path="/blog/1963-hillsdale-amish-school-standoff" element={<HillsdaleAmishSchoolStandoffPost />} />
        <Route path="/blog/amish-in-the-upper-peninsula-michigan" element={<AmishUpperPeninsulaPost />} />
        <Route path="/blog/michigan-amish-fellowship" element={<MichiganAmishFellowshipPost />} />
        <Route path="/blog/cornell-michigan-amish-bakery" element={<CornellAmishBakeryPost />} />
        <Route path="/blog/1965-iowa-amish-cornfield-incident" element={<IowaCornfieldIncident1965Post />} />
        <Route path="/blog/where-are-amish-in-iowa" element={<IowaAmishSettlementsPost />} />
        <Route path="/blog/kalona-iowa-amish-settlement" element={<KalonaIowaPost />} />
        <Route path="/blog/bloomfield-iowa-amish-davis-county" element={<BloomfieldIowaPost />} />
        <Route path="/blog/kalona-historical-village-iowa" element={<KalonaHistoricalVillagePost />} />
        <Route path="/blog/where-are-amish-in-ohio" element={<OhioAmishSettlementsPost />} />
        <Route path="/blog/holmes-county-amish-affiliations" element={<HolmesCounty12AffiliationsPost />} />
        <Route path="/blog/swartzentruber-amish-1913-split" element={<SwartzentruberSplitPost />} />
        <Route path="/blog/amish-country-byway-ohio" element={<AmishCountryBywayPost />} />
        <Route path="/blog/warther-museum-dover-ohio" element={<WartherMuseumPost />} />
        <Route path="/blog/where-are-amish-in-indiana" element={<IndianaAmishSettlementsPost />} />
        <Route path="/blog/swiss-vs-pennsylvania-amish-indiana" element={<SwissVsPennsylvaniaAmishPost />} />
        <Route path="/blog/daviess-county-amish-southern-twang" element={<DaviessCountyTwangPost />} />
        <Route path="/blog/grabill-indiana-amish-village" element={<GrabillIndianaPost />} />
        <Route path="/blog/elkhart-lagrange-amish-rv-industry" element={<ElkhartLagrangeRVPost />} />
        <Route path="/blog/where-are-amish-in-new-york" element={<NewYorkAmishSettlementsPost />} />
        <Route path="/blog/heuvelton-st-lawrence-swartzentruber-amish" element={<HeuveltonSwartzentruberPost />} />
        <Route path="/blog/mohawk-valley-amish-fort-plain" element={<MohawkValleyAmishPost />} />
        <Route path="/blog/new-york-fastest-growing-amish" element={<FastestGrowingAmishStatePost />} />
        <Route path="/blog/ny-amish-trail-leon-conewango" element={<NYAmishTrailLeonPost />} />
        <Route path="/blog/pennsylvania-amish-beyond-lancaster" element={<PennsylvaniaBeyondLancasterPost />} />
        <Route path="/blog/big-valley-buggy-colors" element={<BigValleyBuggyColorsPost />} />
        <Route path="/blog/new-wilmington-brown-topped-amish" element={<NewWilmingtonBrownToppedPost />} />
        <Route path="/blog/smicksburg-pa-amish-country" element={<SmicksburgAmishCountryPost />} />
        <Route path="/blog/nebraska-amish-most-conservative" element={<NebraskaAmishPost />} />
        <Route path="/blog/amish-heritage-foundation-wisconsin-yoder" element={<AmishHeritageFoundationPost />} />
        <Route path="/blog/where-are-amish-in-wisconsin" element={<WisconsinAmishSettlementsPost />} />
        <Route path="/blog/kingston-dalton-wisconsin-amish" element={<KingstonDaltonWisconsinPost />} />
        <Route path="/blog/augusta-wisconsin-amish-chippewa-valley" element={<AugustaWisconsinAmishPost />} />
        <Route path="/blog/grant-county-wisconsin-amish-five-settlements" element={<GrantCountyFiveSettlementsPost />} />
        <Route path="/blog/medford-wisconsin-oldest-amish-settlement" element={<MedfordWisconsinPost />} />
        <Route path="/blog/hillsboro-vernon-richland-wisconsin-amish" element={<HillsboroWisconsinPost />} />
        <Route path="/blog/where-are-amish-in-kentucky" element={<KentuckyAmishSettlementsPost />} />
        <Route path="/blog/guthrie-kentucky-electric-new-order-amish" element={<GuthrieKentuckyPost />} />
        <Route path="/blog/marion-kentucky-home-shop-amish" element={<MarionKentuckyHomeShopPost />} />
        <Route path="/blog/munfordville-hart-county-kentucky-amish" element={<MunfordvilleHartCountyPost />} />
        <Route path="/blog/scottsville-allen-county-kentucky-mennonite" element={<ScottsvilleAllenCountyMennonitePost />} />
        <Route path="/blog/kentucky-amish-migration-1940-1958" element={<KentuckyMigrationPatternsPost />} />
        <Route path="/blog/where-are-amish-in-missouri" element={<MissouriAmishSettlementsPost />} />
        <Route path="/blog/seymour-missouri-conservative-swiss-amish" element={<SeymourMissouriSwissPost />} />
        <Route path="/blog/bowling-green-missouri-oldest-amish" element={<BowlingGreenMissouriPost />} />
        <Route path="/blog/clark-missouri-amish-produce-auction" element={<ClarkMissouriAuctionPost />} />
        <Route path="/blog/missouri-extinct-amish-settlements" element={<MissouriExtinctSettlementsPost />} />
        <Route path="/blog/missouri-amish-growth-since-2010" element={<MissouriAmishGrowthPost />} />
        <Route path="/blog/where-are-amish-in-illinois" element={<IllinoisAmishSettlementsPost />} />
        <Route path="/blog/arthur-illinois-amish-visitor-guide" element={<ArthurIllinoisVisitorGuidePost />} />
        <Route path="/blog/illinois-house-amish-worship" element={<IllinoisHouseAmishPost />} />
        <Route path="/blog/illinois-amish-1865-founding" element={<IllinoisAmish1865Post />} />
        <Route path="/blog/southern-illinois-amish-jackson-union-crawford" element={<SouthernIllinoisAmishPost />} />
        <Route path="/blog/arthur-illinois-amish-furniture-industry" element={<ArthurFurnitureIndustryPost />} />
        <Route path="/blog/where-are-amish-in-minnesota" element={<MinnesotaAmishSettlementsPost />} />
        <Route path="/blog/harmony-minnesota-swartzentruber-amish" element={<HarmonyMinnesotaSwartzentruberPost />} />
        <Route path="/blog/amish-tours-of-harmony-mn" element={<AmishToursHarmonyPost />} />
        <Route path="/blog/todd-county-minnesota-five-amish-settlements" element={<ToddCountyMNSettlementsPost />} />
        <Route path="/blog/wadena-minnesota-oldest-amish" element={<WadenaMNPost />} />
        <Route path="/blog/minnesota-amish-growth-history" element={<MinnesotaAmishGrowthPost />} />
        <Route path="/blog/beverly-lewis-amish-fiction-author-guide" element={<BeverlyLewisAuthorGuidePost />} />
        <Route path="/blog/wanda-brunstetter-amish-fiction-guide" element={<WandaBrunstetterAuthorGuidePost />} />
        <Route path="/blog/growing-up-amish-ira-wagler" element={<GrowingUpAmishWaglerPost />} />
        <Route path="/blog/the-amish-kraybill-johnson-weiner-nolt" element={<TheAmishKraybillBookPost />} />
        <Route path="/blog/linda-castillo-kate-burkholder-series" element={<LindaCastilloKateBurkholderPost />} />
        <Route path="/blog/amish-memoirs-ex-amish-personal-stories" element={<AmishMemoirsExAmishPost />} />
        <Route path="/blog/amish-society-hostetler" element={<AmishSocietyHostetlerBookPost />} />
        <Route path="/blog/amish-strawberry-rhubarb-pie" element={<StrawberryRhubarbPiePost />} />
        <Route path="/blog/amish-wilted-lettuce-salad" element={<WiltedLettuceSaladPost />} />
        <Route path="/blog/amish-rhubarb-crunch" element={<RhubarbCrunchPost />} />
        <Route path="/submit-business" element={<SubmitBusiness />} />
        <Route path="/acf-admin/submissions" element={<AdminSubmissions />} />
        <Route path="/amish-country-events" element={<EventsPage />} />
        <Route path="/blog/amish-greenhouses-ohio-holmes-county" element={<OhioGreenhousesPost />} />
        <Route path="/blog/amish-greenhouses-indiana-shipshewana" element={<IndianaGreenhousesPost />} />
        <Route path="/blog/lancaster-county-amish-country-guide" element={<LancasterCountyPost />} />
        <Route path="/blog/holmes-county-ohio-amish-guide" element={<HolmesCountyPost />} />
        <Route path="/blog/shipshewana-indiana-amish-country-guide" element={<ShipshewanaPost />} />
        <Route path="/amish-stores-vernon-county-wi" element={<VernonCountyPage />} />
        <Route path="/amish-stores-green-lake-county-wi" element={<GreenLakeCountyPage />} />
        <Route path="/amish-stores-cashton-wi" element={<CashtonPage />} />
        <Route path="/amish-stores-dalton-wi" element={<DaltonPage />} />
        <Route path="/amish-stores-ontario-wi" element={<OntarioPage />} />
        <Route path="/amish-stores-kingston-wi" element={<KingstonPage />} />
        {/* HIDDEN PREVIEWS — not in nav/sitemap */}
        <Route path="/map" element={<MapPage />} />
        {/* NATIONAL EXPANSION — hidden, not in nav/sitemap yet */}
        <Route path="/v2" element={<NationalHomePage />} />
        <Route path="/wisconsin" element={<AmishCountryFinder />} />
        <Route path="/wisconsin/vernon-county" element={<VernonCountyDirectoryPage />} />
        <Route path="/wisconsin/monroe-county" element={<MonroeCountyDirectoryPage />} />
        <Route path="/wisconsin/green-lake-county" element={<GreenLakeCountyDirectoryPage />} />
        <Route path="/wisconsin/shawano-county" element={<ShawanoCountyDirectoryPage />} />
        <Route path="/wisconsin/clark-county" element={<ClarkCountyDirectoryPage />} />
        <Route path="/wisconsin/grant-county" element={<GrantCountyWIDirectoryPage />} />
        <Route path="/wisconsin/lafayette-county" element={<LafayetteCountyWIDirectoryPage />} />
        <Route path="/wisconsin-guide" element={<WisconsinPage />} />
        <Route path="/visitor-guide" element={<VisitorGuidePage />} />
        <Route path="/pennsylvania" element={<PennsylvaniaDirectoryPage />} />
        <Route path="/pennsylvania-guide" element={<PennsylvaniaPage />} />
        <Route path="/pennsylvania/lancaster-county" element={<LancasterCountyDirectoryPage />} />
        <Route path="/pennsylvania/crawford-county" element={<CrawfordCountyDirectoryPage />} />
        <Route path="/pennsylvania/lawrence-county" element={<LawrenceCountyDirectoryPage />} />
        <Route path="/pennsylvania/mifflin-county" element={<MifflinCountyDirectoryPage />} />
        <Route path="/ohio" element={<OhioDirectoryPage />} />
        <Route path="/ohio-guide" element={<OhioPage />} />
        <Route path="/ohio/holmes-county" element={<HolmesCountyDirectoryPage />} />
        <Route path="/ohio/wayne-county" element={<WayneCountyOhioDirectoryPage />} />
        <Route path="/ohio/tuscarawas-county" element={<TuscarawasCountyDirectoryPage />} />
        <Route path="/ohio/geauga-county" element={<GeaugaCountyDirectoryPage />} />
        <Route path="/indiana" element={<IndianaDirectoryPage />} />
        <Route path="/indiana-guide" element={<IndianaPage />} />
        <Route path="/indiana/lagrange-county" element={<LaGrangeCountyDirectoryPage />} />
        <Route path="/indiana/elkhart-county" element={<ElkhartCountyDirectoryPage />} />
        <Route path="/indiana/daviess-county" element={<DaviessCountyDirectoryPage />} />
        <Route path="/new-york" element={<NewYorkDirectoryPage />} />
        <Route path="/new-york-guide" element={<NewYorkPage />} />
        <Route path="/new-york/cattaraugus-county" element={<CattaraugusCountyDirectoryPage />} />
        <Route path="/new-york/yates-county" element={<YatesCountyDirectoryPage />} />
        <Route path="/new-york/st-lawrence-county" element={<StLawrenceCountyDirectoryPage />} />
        <Route path="/michigan" element={<MichiganDirectoryPage />} />
        <Route path="/michigan-guide" element={<MichiganPage />} />
        <Route path="/michigan/st-joseph-county" element={<StJosephCountyMIDirectoryPage />} />
        <Route path="/michigan/hillsdale-county" element={<HillsdaleCountyDirectoryPage />} />
        <Route path="/minnesota" element={<MinnesotaDirectoryPage />} />
        <Route path="/minnesota/fillmore-county" element={<FillmoreCountyDirectoryPage />} />
        <Route path="/minnesota/houston-county" element={<HoustonCountyDirectoryPage />} />
        <Route path="/amish-greenhouses" element={<GreenhousesPage />} />
        <Route path="/printable-guides" element={<PrintableGuides />} />
        <Route path="/printable-guides/submit" element={<SubmitPDF />} />
        <Route path="/print/wisconsin-dells-amish-guide" element={<WisconsinDellsGuide />} />
        <Route path="/print/holmes-county-amish-guide" element={<HolmesCountyGuide />} />
        <Route path="/print/jamesport-missouri-amish-guide" element={<JamesportGuide />} />
        <Route path="/print/arthur-arcola-illinois-amish-guide" element={<ArthurArcolaGuide />} />
        <Route path="/print/shipshewana-indiana-amish-guide" element={<ShipshewanaGuide />} />
        <Route path="/missouri" element={<MissouriDirectoryPage />} />
        <Route path="/missouri/daviess-county" element={<DaviessCountyMODirectoryPage />} />
        <Route path="/kentucky" element={<KentuckyDirectoryPage />} />
        <Route path="/kentucky-guide" element={<KentuckyPage />} />
        <Route path="/kentucky/grayson-county" element={<GraysonCountyKYDirectoryPage />} />
        <Route path="/kentucky/hart-county" element={<HartCountyKYDirectoryPage />} />
        <Route path="/kentucky/logan-county" element={<LoganCountyKYDirectoryPage />} />
        <Route path="/illinois" element={<IllinoisDirectoryPage />} />
        <Route path="/illinois/douglas-county" element={<DouglasCountyILDirectoryPage />} />
        <Route path="/illinois-guide" element={<IllinoisPage />} />
        <Route path="/iowa" element={<IowaDirectoryPage />} />
        <Route path="/iowa-guide" element={<IowaPage />} />
        <Route path="/iowa/washington-county" element={<WashingtonCountyIADirectoryPage />} />
        <Route path="/iowa/davis-county" element={<DavisCountyIADirectoryPage />} />
        <Route path="/guides/:token" element={<GuidePage />} />
        <Route path="/businesses/:slug" element={<BusinessPage />} />
        <Route path="/my-trip" element={<TripList />} />
        <Route path="/acf-admin/businesses" element={<AdminBusinesses />} />
        <Route path="/near-me" element={<NearMe />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes></Suspense>
      <SiteFooter />
      <Analytics />
    </BrowserRouter>
  );
}

export default App;